import Header from './Header';
import Nav from './Nav';
import Footer from './Footer';
import Home from './Home';
import NewPost from './NewPost';
import PostPage from './PostPage';
import About from './About';
import NotFound from './NotFound';
import {Route,Routes,BrowserRouter as Router,useNavigate, Navigate} from 'react-router-dom';
import {useState,useEffect} from 'react'
import api from './api/posts';
import EditPost from './EditPost';
import LoginUI from './LoginUI';
import LogOutUI from './LogOutUI';
import ProtectedRoute from './ProtectedRoute';
import Report from './Report';
import UserDetails from './UserDetails';
import Spinner from 'react-bootstrap/Spinner';


import MoreOptions from './MoreOptions';
import NavAdmin from './NavAdmin';
import UserNav from './UserNav';
import HomeAdmin from './HomeAdmin';
import AdminSearch from './AdminSearch';
import AdminSearchPanle from './AdminSearchPanel';

function App() {  
  const [posts,setPosts]=useState([]);  
  const [accessToken,setAccessToken]=useState(''); 
  const [isAuthenticated,setIsAuthenticated]=useState(false); 
  const [isAppLoaded,setIsAppLoaded]=useState(false); 

  const [searchString,setSearchString]=useState('');
  const [searchResult,setSearchResult]=useState([]);
  const [editPostTitle,setEditPostTitle]=useState('');
  const [editPostBody,setEditPostBody]=useState('');

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const toggleShow = () => setShow((s) => !s);



  const [userFullName,setUserFullName]=useState('');
  const [userName,setUserName]=useState('');
  const [lt,setLt]=useState('');
  const [refreshFailed,setRefreshFailed]=useState(true);
  
  const[stats,setStats]=useState({AssesmentCount:0,VillageCount:0,TeamCount:0,AssesmentCountToday:0,VillageCountToday:0,TeamCountToday:0})
  const[dhtStat,setDhtStat]=useState({})

  const [searchStringAdmin,setSearchStringAdmin]=useState('');
  const [searchTeam,setSearchTeam]=useState('');
  const [searchPosts,setSearchPosts]=useState([]);
  const [isSearchPage,setIsSearchPage]=useState(false);

  const villages=[];
    
  
  useEffect(()=>{
    
    const fetchAT=async ()=>{
          try{
            const config = { withCredentials: true };
            const x=await api.get('/getAccessToken',config);   
            //alert("app load 1 "+JSON.stringify(x));         
            const nat=x['data']['accessToken'];
            const ufn=x['data']['userFullName'];
            const un=x['data']['userName'];
            const ltx=x['data']['loginType'];
            setLt(ltx);
            setAccessToken(nat);   
            setIsAuthenticated(true);   
            setUserFullName(ufn);    
            setUserName(un);
                    
            setRefreshFailed(false);
            if(lt.toLowerCase()==="employee")
            {
                  try{       
                    const x=await api.get('/employees',{headers:{'Authorization':`Bearer ${nat}`}});
                    setPosts(x.data);
                    //alert("app loaded "+JSON.stringify(x.data));
                }
                catch(err)
                {
                  //alert('refresh failed unusual 1'+JSON.stringify(err));
                  //setAccessToken('');   
                  //setIsAuthenticated(false); 
                  //setUserFullName(''); 
                }
              }
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        //setStats(response.data);  
                        //const response2=await api.get('/statsdht',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        //setDhtStat(response2.data);  
                        //alert('read');
                    }
                    catch(err)
                    {
                      alert('refresh failed unusual'+JSON.stringify(err));
                      //setAccessToken('');   
                      //setIsAuthenticated(false); 
                      //setUserFullName(''); 
                    }
                  }
            }
            catch(err)
            {
              //alert("sss");
              setAccessToken('');   
              setIsAuthenticated(false);    
              setUserFullName('');  
              setUserName('');  
              setRefreshFailed(true);              
            }
            finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    }
    fetchAT();
  },[refreshFailed]);
  
  
  const handleDelete=async (id)=>{
    /*try{
      await api.delete('/posts/'+id.toString());
      const filteredPosts=posts.filter(
        (post)=>{
          return post.id!=id
        }
       )
       setPosts(filteredPosts);
       //Navigate('/');
    }
    catch(err)
    {
         console.log(err.message);
    }
     */
    let i=0;
  }
 
  useEffect(()=>{
    /*const filteredPosts=posts.filter((post)=>{
      return post.body.toLowerCase().includes(searchString.toLowerCase())
              || post.title.toLowerCase().includes(searchString.toLowerCase())
    });
    //console.log(JSON.stringify(filteredPosts));
    */
    setSearchResult(posts);
  },[posts,searchString])

  //alert(userName);
  return (
    <Router>
      <div className="App">
        {<Header></Header>}
        { (isAppLoaded)&&!refreshFailed &&(lt.toLowerCase()==="admin")&& <NavAdmin       
          searchString={searchString}
          setSearchString={setSearchString}
          />}
          { (isAppLoaded)&&!refreshFailed &&(lt.toLowerCase()!=="admin")&& <Nav 
          searchString={searchString}
          setSearchString={setSearchString}
          />}
          { (isAppLoaded)&&refreshFailed&& <UserNav 
          searchString={searchString}
          setSearchString={setSearchString}
          />}

        { (isAppLoaded) &&!refreshFailed &&(lt.toLowerCase()==="admin")&&
          <>
          <UserDetails isSearchPage={isSearchPage} userName={userName} userFullName={userFullName} refreshFailed={refreshFailed} searchPosts={searchPosts} searchStringAdmin={searchStringAdmin} />
          <Routes>
          <Route element={<ProtectedRoute isAuthenticated={isAuthenticated}/>}>
          <Route path='/' element={<>
                        <AdminSearchPanle
                        accessToken={accessToken} 
                        setAccessToken={setAccessToken}
                        setRefreshFailed={setRefreshFailed}
                        searchStringAdmin={searchStringAdmin}
                        setSearchStringAdmin={setSearchStringAdmin}
                        searchTeam={searchTeam}
                        setSearchTeam={setSearchTeam}
                        searchPosts={searchPosts}
                        setSearchPosts={setSearchPosts}
                        isSearchPage={isSearchPage}
                        setIsSearchPage={setIsSearchPage}
                        />
                        <AdminSearch
                        posts={searchPosts}
                        searchString={searchStringAdmin}
                        /></>}> 
              </Route>

              <Route  path='/post' element={<NewPost
                        posts={posts}
                        setPosts={setPosts}
                        accessToken={accessToken} 
                        setAccessToken={setAccessToken}
                        villages={villages}
                        />}>            
              </Route>
              <Route  path='/post/:id' element={<PostPage 
                           posts={posts}
                           setPosts={setPosts}
                           accessToken={accessToken} 
                           setAccessToken={setAccessToken}                           
                           handleDelete={handleDelete}
                          />
                          }>                          
              </Route> 
              <Route  path='/searchpost/:id' element={<PostPage 
                           posts={searchPosts}
                           setPosts={setPosts}
                           accessToken={accessToken} 
                           setAccessToken={setAccessToken}                           
                           handleDelete={handleDelete}
                           mode={'admin'}
                          />
                          }>                          
              </Route>
            
              <Route  path='/edit/:id' element={<EditPost
                        posts={posts}
                        setPosts={setPosts}
                        accessToken={accessToken} 
                        setAccessToken={setAccessToken}
                        villages={villages}
                        />}>            
              </Route>
              <Route path='/moreoptions' element={<MoreOptions
                        />}> 
              </Route>

              <Route path='/report' element={<Report
                        accessToken={accessToken} 
                        setAccessToken={setAccessToken}
                        posts={posts}
                        userName={userName}
                        />}> 
              </Route>
              <Route path='/AdminSearch' element={<>
                        <AdminSearchPanle
                        accessToken={accessToken} 
                        setAccessToken={setAccessToken}
                        setRefreshFailed={setRefreshFailed}
                        searchStringAdmin={searchStringAdmin}
                        setSearchStringAdmin={setSearchStringAdmin}
                        searchTeam={searchTeam}
                        setSearchTeam={setSearchTeam}
                        searchPosts={searchPosts}
                        setSearchPosts={setSearchPosts}
                        isSearchPage={isSearchPage}
                        setIsSearchPage={setIsSearchPage}
                        />
                        <AdminSearch
                        posts={searchPosts}
                        searchString={searchStringAdmin}
                        /></>}> 
              </Route>
          </Route>
         
        
          <Route  path='/about' element={<About></About>}></Route>
          <Route path='*' element={<NotFound></NotFound>}></Route>

          <Route  path='/login' element={!isAuthenticated? <LoginUI
                setRefreshFailed={setRefreshFailed} refreshFailed={refreshFailed} userFullName={userFullName} setUserFullName={setUserFullName} userName={userName} setUserName={setUserName} setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated}/>:<Navigate to="/" />}>            
          </Route>
          <Route  path='/logout' element={isAuthenticated? <LogOutUI
          setSearchResult={setSearchResult} setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated} setRefreshFailed={setRefreshFailed}/>:<Navigate to="/Login" />}>            
          </Route>
          </Routes>
          </>
        }
      { (isAppLoaded) &&!refreshFailed && (lt.toLowerCase()!=="admin")&&
          <>
          <UserDetails userName={userName} posts={posts} searchString={searchString} userFullName={userFullName} refreshFailed={refreshFailed} />
          <Routes>
          <Route element={<ProtectedRoute isAuthenticated={isAuthenticated}/>}>
              <Route  path='/' element={<Home 
                        posts={searchResult}
                        setPosts={setPosts} 
                        accessToken={accessToken} 
                        setAccessToken={setAccessToken}
                        userFullName={userFullName}
                        userName={userName}
                        setUserName={setUserName}
                        refreshFailed={refreshFailed}
                        setRefreshFailed={setRefreshFailed}
                        searchString={searchString}
                        />}>            
              </Route>

              <Route  path='/post' element={<NewPost
                        posts={posts}
                        setPosts={setPosts}
                        accessToken={accessToken} 
                        setAccessToken={setAccessToken}
                        villages={villages}
                        />}>            
              </Route>
              <Route  path='/post/:id' element={<PostPage 
                           posts={posts}
                           setPosts={setPosts}
                           accessToken={accessToken} 
                           setAccessToken={setAccessToken} 
                          />
                          }>                          
              </Route>
            
              <Route  path='/edit/:id' element={<EditPost
                        posts={posts}
                        setPosts={setPosts}
                        accessToken={accessToken} 
                        setAccessToken={setAccessToken}
                        villages={villages}
                        />}>            
              </Route>
              <Route path='/more' element={<MoreOptions
                        accessToken={accessToken} 
                        setAccessToken={setAccessToken}
                        />}> 
              </Route>

              <Route path='/report' element={<Report
                        accessToken={accessToken} 
                        setAccessToken={setAccessToken}
                        posts={posts}
                        userName={userName}
                        />}> 
              </Route>
          </Route>
         
        
          <Route  path='/about' element={<About></About>}></Route>
          <Route path='*' element={<NotFound></NotFound>}></Route>

          <Route  path='/login' element={!isAuthenticated? <LoginUI
                setRefreshFailed={setRefreshFailed} refreshFailed={refreshFailed} userFullName={userFullName} setUserFullName={setUserFullName} userName={userName} setUserName={setUserName} setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated}/>:<Navigate to="/" />}>            
          </Route>
          <Route  path='/logout' element={isAuthenticated? <LogOutUI
          setSearchResult={setSearchResult} setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated} setRefreshFailed={setRefreshFailed}/>:<Navigate to="/Login" />}>            
          </Route>
          </Routes>
          </>
      }
      
      {
        !isAppLoaded &&
          <div className='spinneroverlay'>
            <div className='spinnerbody'>
              <Spinner animation="border" variant="info" />
              <p>Please wait. It might take a few seconds.</p>
            </div>           
          </div>
      }
      {
       (isAppLoaded) && refreshFailed && 
        <>
        <Routes>
        <Route  path='/about' element={<About></About>}></Route>
          <Route path='*' element={ <LoginUI
                setRefreshFailed={setRefreshFailed} refreshFailed={refreshFailed} userFullName={userFullName} setUserFullName={setUserFullName} userName={userName} setUserName={setUserName} setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated}/>}>            
                </Route>

          <Route  path='/login' element={ <LoginUI
                setRefreshFailed={setRefreshFailed} refreshFailed={refreshFailed} userFullName={userFullName} setUserFullName={setUserFullName} userName={userName} setUserName={setUserName} setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated}/>}>            
          </Route>
          <Route  path='/logout' element={ <LogOutUI
          setSearchResult={setSearchResult} setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated} setRefreshFailed={setRefreshFailed}/>}>            
          </Route>
        </Routes>
        </>
      }

        <Footer></Footer>
      </div>
    </Router>
  );
}

export default App;
